import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class PersonalContactInformation extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_personal_contact_information');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'aadhaar_card')}><i class="fas fa-file-download"></i> Aadhaar Card</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'bank_passbook')}><i class="fas fa-file-download"></i> Bank Account Passbook</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'part_time_employee_personal_contact_information';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#emp_full_name').val(data['emp_full_name']);
    $('#bate_of_birth').val(data['bate_of_birth']);
    $('#user_age').val(data['user_age']);
    $('#gender').val(data['gender']);
    $('#nationality').val(data['nationality']);
    $('#residential_address').val(data['residential_address']);
    $('#communication_address').val(data['communication_address']);
    $('#mobile_number').val(data['mobile_number']);
    $('#alternate_contact').val(data['alternate_contact']);
    $('#professional_email').val(data['professional_email']);
    $('#pan_number').val(data['pan_number']);
    $('#bank_name').val(data['bank_name']);
    $('#account_number').val(data['account_number']);
    $('#ifsc_number').val(data['ifsc_number']);
    $('#branch_name').val(data['branch_name']);

    $('#old_aadhaar_card').val(data['aadhaar_card_new_name']);
    $('#old_bank_passbook').val(data['bank_passbook_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var emp_full_name    = window.isNullAndUndef($('#emp_full_name').val());
    var bate_of_birth          = window.isNullAndUndef($('#bate_of_birth').val());
    var user_age           = window.isNullAndUndef($('#user_age').val());
    var gender              = window.isNullAndUndef($('#gender').val());
    var nationality         = window.isNullAndUndef($('#nationality').val());
    var residential_address         = window.isNullAndUndef($('#residential_address').val());
    var communication_address         = window.isNullAndUndef($('#communication_address').val());
    var mobile_number         = window.isNullAndUndef($('#mobile_number').val());
    var alternate_contact     = window.isNullAndUndef($('#alternate_contact').val());
    var professional_email     = window.isNullAndUndef($('#professional_email').val());
    var pan_number     = window.isNullAndUndef($('#pan_number').val());
    var bank_name     = window.isNullAndUndef($('#bank_name').val());
    var account_number     = window.isNullAndUndef($('#account_number').val());
    var ifsc_number     = window.isNullAndUndef($('#ifsc_number').val());
    var branch_name     = window.isNullAndUndef($('#branch_name').val());

    var aadhaar_card_temp    = window.isNullAndUndef($('#aadhaar_card').val());
    var org_aadhaar_card     = $("#aadhaar_card").prop("files")[0];
    var aadhaar_card_name    = $('#aadhaar_card').val().split('\\').pop();

    var bank_passbook_temp        = window.isNullAndUndef($('#bank_passbook').val());
    var org_bank_passbook         = $("#bank_passbook").prop("files")[0];
    var bank_passbook_name        = $('#bank_passbook').val().split('\\').pop();


    var aadhaar_card_ext    = '';
    var bank_passbook_ext  = '';

    if(aadhaar_card_temp && bank_passbook_temp){
      aadhaar_card_ext       = aadhaar_card_temp.split('.').pop();
      bank_passbook_ext        = bank_passbook_temp.split('.').pop();
    }
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(emp_full_name && bate_of_birth && user_age && gender && nationality && residential_address && communication_address && mobile_number && alternate_contact && professional_email && pan_number && bank_name && account_number && ifsc_number && branch_name && file_main_ext.indexOf(aadhaar_card_ext) >= 0 && file_main_ext.indexOf(bank_passbook_ext) >= 0){
      var old_aadhaar_card                 = $('#old_aadhaar_card').val();
      var old_bank_passbook                  = $('#old_bank_passbook').val();
      var all_data                              = {};
      all_data['emp_full_name']        = window.return_false_null(emp_full_name);
      all_data['bate_of_birth']              = window.return_false_null(bate_of_birth);
      all_data['user_age']               = window.return_false_null(user_age);
      all_data['gender']                  = window.return_false_null(gender);
      all_data['nationality']             = window.return_false_null(nationality);
      all_data['residential_address']             = window.return_false_null(residential_address);
      all_data['communication_address']             = window.return_false_null(communication_address);
      all_data['mobile_number']             = window.return_false_null(mobile_number);
      all_data['alternate_contact']             = window.return_false_null(alternate_contact);
      all_data['professional_email']             = window.return_false_null(professional_email);
      all_data['pan_number']             = window.return_false_null(pan_number);
      all_data['bank_name']             = window.return_false_null(bank_name);
      all_data['account_number']             = window.return_false_null(account_number);
      all_data['ifsc_number']             = window.return_false_null(ifsc_number);
      all_data['branch_name']             = window.return_false_null(branch_name);

      all_data['aadhaar_card']             = window.return_false_null(aadhaar_card_name);
      all_data['bank_passbook']                 = window.return_false_null(bank_passbook_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('aadhaar_card',org_aadhaar_card);
      body.append('bank_passbook',org_bank_passbook);
      body.append('old_aadhaar_card',old_aadhaar_card);
      body.append('old_bank_passbook',old_bank_passbook);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_personal_contact_information');
      body.append('function','add_part_time_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('emp_full_name','bate_of_birth','user_age','gender','nationality','residential_address','communication_address','mobile_number','alternate_contact','professional_email','pan_number','bank_name','account_number','ifsc_number','branch_name','aadhaar_card','bank_passbook');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="emp_full_name" placeholder="Full Name"/>
                                        <label for="name">Full Name</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="bate_of_birth" placeholder="Date of Birth"/>
                                        <label for="name">Date of Birth</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="user_age" placeholder="Date of Birth"/>
                                        <label for="name">Age</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="gender" name="form_type">
                                        <option value="">Gender</option>
                                        <option value="Female">Female</option>
                                        <option value="Male">Male</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <label for="name">Gender</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="nationality" placeholder="Nationality"/>
                                        <label for="name">Nationality</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="residential_address" placeholder="Residential Address"/>
                                        <label for="name">Residential Address</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="communication_address" placeholder="Communication Address"/>
                                        <label for="name">Communication Address</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="mobile_number" placeholder="Mobile Number"/>
                                        <label for="name">Mobile Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="alternate_contact" placeholder="Alternate Contact"/>
                                        <label for="name">Alternate Contact</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="professional_email" placeholder="Email ID (Personal &amp; Professional)"/>
                                        <label for="name">Email ID (Personal &amp; Professional)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_aadhaar_card" placeholder=""/>
                                        <input type="file" className="form-control" id="aadhaar_card" placeholder="Aadhaar Card"/>
                                        <label for="name">Aadhaar Card</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="pan_number" placeholder="PAN Card"/>
                                        <label for="name">PAN Card</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_bank_passbook" placeholder=""/>
                                        <input type="file" className="form-control" id="bank_passbook" placeholder="Bank Account Passbook"/>
                                        <label for="name">Bank Account Passbook</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="bank_name" placeholder="Bank Name"/>
                                        <label for="name">Bank Name</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="account_number" placeholder="Account Number"/>
                                        <label for="name">Account Number</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="ifsc_number" placeholder="IFSC Code"/>
                                        <label for="name">IFSC Code</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="branch_name" placeholder="Branch Name"/>
                                        <label for="name">Branch Name</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow JPEG, JPG & PNG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default PersonalContactInformation;
